import React, { FC, ReactElement } from 'react';

interface HistoryCardProps {
  year: number;
  history: ReactElement;
}

export const HistoryCard: FC<HistoryCardProps> = ({ year, history }) => {
  return (
    <div className="space-y-7">
      <div className="flex items-center space-x-4">
        <div className="grid h-14 w-14 flex-none place-content-center rounded-full bg-black">
          <p className="font-semibold text-white">{year}</p>
        </div>
        <div className="w-full border border-black/10" />
      </div>

      <div className="text-[14px] font-medium text-[#666666]">{history}</div>
    </div>
  );
};
